// Bengali translations
export const bn: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'লোড হচ্ছে...',
  'common.error': 'একটি ত্রুটি হয়েছে',
  'common.retry': 'আবার চেষ্টা করুন',
  'common.cancel': 'বাতিল',
  'common.save': 'সংরক্ষণ',
  'common.continue': 'চালিয়ে যান',
  'common.back': 'পিছনে',
  'common.next': 'পরবর্তী',
  'common.skip': 'এড়িয়ে যান',
  'common.done': 'সম্পন্ন',
  'common.yes': 'হ্যাঁ',
  'common.no': 'না',
  'common.ok': 'ঠিক আছে',
  'common.check': 'পরীক্ষা করুন',
  'common.correct': 'সঠিক!',
  'common.incorrect': 'ভুল',
  'common.tryAgain': 'আবার চেষ্টা করুন',
  'common.start': 'শুরু করুন',
  'common.finish': 'শেষ',
  'common.submit': 'জমা দিন',

  // ==================== NAVIGATION ====================
  'nav.home': 'হোম',
  'nav.courses': 'কোর্স',
  'nav.vocabulary': 'শব্দভাণ্ডার',
  'nav.profile': 'প্রোফাইল',
  'nav.settings': 'সেটিংস',
  'nav.logout': 'লগ আউট',
  'nav.leaderboard': 'লিডারবোর্ড',
  'nav.aiTutor': 'AI টিউটর',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'KoreanFlow-এ স্বাগতম!',
  'onboarding.selectLanguage': 'আপনার ভাষা নির্বাচন করুন',
  'onboarding.selectLanguageDesc': 'অ্যাপ ইন্টারফেসের জন্য ভাষা বেছে নিন',
  'onboarding.selectGoal': 'আপনার শেখার লক্ষ্য কী?',
  'onboarding.selectGoalDesc': 'আমরা আপনার জন্য শেখার পথ তৈরি করব',
  'onboarding.takeTest': 'লেভেল টেস্ট দিন',
  'onboarding.takeTestDesc': '৫ মিনিটে আপনার কোরিয়ান স্তর জানুন',
  'onboarding.skipTest': 'এখন এড়িয়ে যান',
  'onboarding.skipTestDesc': 'শুরু থেকে শুরু করুন',
  'onboarding.letsGo': 'চলুন শুরু করি!',
  'onboarding.step': 'ধাপ',
  'onboarding.of': 'এর',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'লেভেল টেস্ট',
  'levelTest.subtitle': 'আসুন আপনার কোরিয়ান স্তর জানি',
  'levelTest.duration': 'প্রায় ৫ মিনিট',
  'levelTest.questions': 'প্রশ্ন',
  'levelTest.vocabulary': 'শব্দভাণ্ডার',
  'levelTest.grammar': 'ব্যাকরণ',
  'levelTest.listening': 'শোনা',
  'levelTest.speaking': 'বলা',
  'levelTest.analyzing': 'আপনার ফলাফল বিশ্লেষণ হচ্ছে...',
  'levelTest.yourLevel': 'আপনার স্তর',
  'levelTest.congratulations': 'অভিনন্দন!',
  'levelTest.resultDesc': 'আপনার টেস্ট ফলাফলের ভিত্তিতে',
  'levelTest.startLearning': 'শেখা শুরু করুন',
  'levelTest.retakeTest': 'আবার টেস্ট দিন',
  'levelTest.sectionComplete': 'বিভাগ সম্পন্ন',
  'levelTest.nextSection': 'পরবর্তী বিভাগ',
  'levelTest.listenAndAnswer': 'শুনুন এবং উত্তর দিন',
  'levelTest.speakNow': 'এখন বলুন',
  'levelTest.tapToListen': 'শুনতে ট্যাপ করুন',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'শিক্ষানবিশ',
  'cefr.A2': 'প্রাথমিক',
  'cefr.B1': 'মধ্যবর্তী',
  'cefr.B2': 'উচ্চ মধ্যবর্তী',
  'cefr.C1': 'উন্নত',
  'cefr.C2': 'দক্ষতা',
  'cefr.A1.desc': 'মৌলিক অভিবাদন এবং সহজ অভিব্যক্তি',
  'cefr.A2.desc': 'দৈনন্দিন জীবন সম্পর্কে সহজ কথোপকথন',
  'cefr.B1.desc': 'বেশিরভাগ ভ্রমণ পরিস্থিতি সামলাতে পারেন',
  'cefr.B2.desc': 'স্থানীয় বক্তাদের সাথে সাবলীলভাবে কথা বলতে পারেন',
  'cefr.C1.desc': 'ধারণাগুলো সাবলীলভাবে এবং স্বতঃস্ফূর্তভাবে প্রকাশ করতে পারেন',
  'cefr.C2.desc': 'সব পরিস্থিতিতে প্রায় স্থানীয়দের মতো দক্ষতা',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'লিগ',
  'league.weeklyRanking': 'সাপ্তাহিক র‍্যাংকিং',
  'league.bronze': 'ব্রোঞ্জ',
  'league.silver': 'সিলভার',
  'league.gold': 'গোল্ড',
  'league.platinum': 'প্লাটিনাম',
  'league.diamond': 'ডায়মন্ড',
  'league.promotion': 'প্রমোশন জোন',
  'league.demotion': 'ডিমোশন জোন',
  'league.safe': 'নিরাপদ জোন',
  'league.weeklyXP': 'সাপ্তাহিক XP',
  'league.rank': 'র‍্যাংক',
  'league.daysLeft': 'দিন বাকি',
  'league.promoted': 'প্রমোট হয়েছেন!',
  'league.demoted': 'ডিমোট হয়েছেন',
  'league.stayed': 'রয়ে গেছেন',
  'league.noData': 'এখনও কোনো র‍্যাংকিং ডেটা নেই',
  'league.earnXP': 'লিগে যোগ দিতে XP অর্জন করুন!',
  'league.topPercent': 'শীর্ষ {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': '#১ কোরিয়ান শেখার অ্যাপ',
  'landing.title': 'কোরিয়ান শিখুন',
  'landing.titleAccent': 'মজার উপায়ে',
  'landing.subtitle': 'ছোট পাঠ, K-Pop এবং K-Drama কনটেন্ট, এবং AI-চালিত উচ্চারণ প্রতিক্রিয়ার মাধ্যমে কোরিয়ানে দক্ষতা অর্জন করুন। ১০ লাখ+ শিক্ষার্থীদের সাথে যোগ দিন!',
  'landing.getStarted': 'বিনামূল্যে শুরু করুন',
  'landing.learnMore': 'আরও জানুন',
  'landing.login': 'লগ ইন',
  'landing.startFree': 'বিনামূল্যে শুরু',
  'landing.learners': 'শিক্ষার্থী',
  'landing.lessons': 'পাঠ',
  'landing.countries': 'দেশ',

  // ==================== FEATURES ====================
  'features.title': 'কেন KoreanFlow?',
  'features.subtitle': 'আমাদের অনন্য পদ্ধতি গেমিফিকেশন, প্রামাণিক কনটেন্ট এবং AI প্রযুক্তিকে একত্রিত করে কোরিয়ান শেখাকে মজাদার এবং কার্যকর করে তোলে।',
  'features.streaks.title': 'দৈনিক স্ট্রিক',
  'features.streaks.desc': 'দৈনিক লক্ষ্য এবং স্ট্রিক পুরস্কারের মাধ্যমে অভ্যাস গড়ে তুলুন। XP এবং জেমস দিয়ে অনুপ্রাণিত থাকুন।',
  'features.folksong.title': 'লোকগীতি',
  'features.folksong.desc': 'ঐতিহ্যবাহী লোকগীতির মাধ্যমে কোরিয়ান শিখুন। গানের কথা এবং সংস্কৃতি বুঝুন!',
  'features.culture.title': 'কোরিয়ান সংস্কৃতি',
  'features.culture.desc': 'প্রবাদ, স্ল্যাং এবং প্রয়োজনীয় বাক্যাংশ অন্বেষণ করুন। খাঁটি অভিব্যক্তি আয়ত্ত করুন।',
  'features.ai.title': 'AI চ্যাটবট',
  'features.ai.desc': 'আমাদের AI টিউটরের সাথে কথোপকথন অনুশীলন করুন। তাৎক্ষণিক প্রতিক্রিয়া এবং সংশোধন পান।',
  'features.leaderboard.title': 'লিডারবোর্ড',
  'features.leaderboard.desc': 'বন্ধুদের এবং বিশ্বব্যাপী শিক্ষার্থীদের সাথে প্রতিযোগিতা করুন। সাপ্তাহিক র‍্যাংকিংয়ে উপরে উঠুন!',
  'features.srs.title': 'SRS শব্দভাণ্ডার',
  'features.srs.desc': 'স্মার্ট পুনরাবৃত্তি সিস্টেম নিশ্চিত করে যে আপনি যা শিখেছেন তা মনে থাকবে। চিরকাল।',
  'features.pronunciation.title': 'উচ্চারণ প্রতিক্রিয়া',
  'features.pronunciation.desc': 'বিস্তারিত স্কোরিং সহ AI-চালিত উচ্চারণ বিশ্লেষণ।',

  // ==================== CTA ====================
  'cta.title': 'আপনার যাত্রা শুরু করতে প্রস্তুত?',
  'cta.subtitle': 'লক্ষ লক্ষ শিক্ষার্থীদের সাথে যোগ দিন এবং আজই কোরিয়ান বলা শুরু করুন। এটি বিনামূল্যে!',
  'cta.button': 'বিনামূল্যে শেখা শুরু করুন',

  // ==================== AUTH ====================
  'auth.login': 'লগ ইন',
  'auth.register': 'সাইন আপ',
  'auth.email': 'ইমেইল',
  'auth.emailPlaceholder': 'আপনার ইমেইল লিখুন',
  'auth.password': 'পাসওয়ার্ড',
  'auth.passwordPlaceholder': 'একটি পাসওয়ার্ড তৈরি করুন',
  'auth.confirmPassword': 'পাসওয়ার্ড নিশ্চিত করুন',
  'auth.forgotPassword': 'পাসওয়ার্ড ভুলে গেছেন?',
  'auth.noAccount': 'অ্যাকাউন্ট নেই?',
  'auth.haveAccount': 'ইতিমধ্যে অ্যাকাউন্ট আছে?',
  'auth.orContinueWith': 'অথবা এর সাথে চালিয়ে যান',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'অ্যাকাউন্ট তৈরি করুন',
  'auth.createAccountTitle': 'আপনার অ্যাকাউন্ট তৈরি করুন',
  'auth.createAccountSubtitle': 'আজই আপনার কোরিয়ান শেখার যাত্রা শুরু করুন',
  'auth.username': 'ইউজারনেম',
  'auth.usernamePlaceholder': 'একটি ইউজারনেম বেছে নিন',
  'auth.usernameHint': 'শুধুমাত্র অক্ষর, সংখ্যা এবং আন্ডারস্কোর',
  'auth.passwordHint': 'বড় হাতের অক্ষর, ছোট হাতের অক্ষর এবং সংখ্যা সহ কমপক্ষে ৮ অক্ষর',
  'auth.nativeLanguage': 'মাতৃভাষা',
  'auth.nativeLanguageHint': 'আমরা এই ভাষায় ব্যাখ্যা দেখাব',
  'auth.termsAgree': 'সাইন আপ করে, আপনি আমাদের মেনে নিচ্ছেন',
  'auth.terms': 'শর্তাবলী',
  'auth.and': 'এবং',
  'auth.privacyPolicy': 'গোপনীয়তা নীতি',
  'auth.loginTitle': 'স্বাগতম',
  'auth.loginSubtitle': 'শেখা চালিয়ে যেতে সাইন ইন করুন',
  'auth.loginButton': 'লগ ইন',
  'auth.registerButton': 'সাইন আপ',
  'auth.rememberMe': 'আমাকে মনে রাখুন',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'স্বাগতম',
  'dashboard.todayGoal': 'আজকের লক্ষ্য',
  'dashboard.streak': 'স্ট্রিক',
  'dashboard.days': 'দিন',
  'dashboard.xp': 'XP',
  'dashboard.level': 'স্তর',
  'dashboard.continueLearning': 'শেখা চালিয়ে যান',
  'dashboard.recommended': 'আপনার জন্য সুপারিশকৃত',
  'dashboard.myCourses': 'আমার কোর্স',
  'dashboard.seeAll': 'সব দেখুন',
  'dashboard.dailyGoalComplete': 'দৈনিক লক্ষ্য সম্পন্ন!',
  'dashboard.keepGoing': 'চালিয়ে যান!',
  'dashboard.yourLevel': 'আপনার স্তর',
  'dashboard.weeklyProgress': 'সাপ্তাহিক অগ্রগতি',

  // ==================== COURSES ====================
  'courses.title': 'সব কোর্স',
  'courses.search': 'কোর্স খুঁজুন...',
  'courses.all': 'সব',
  'courses.beginner': 'শিক্ষানবিশ',
  'courses.elementary': 'প্রাথমিক',
  'courses.intermediate': 'মধ্যবর্তী',
  'courses.advanced': 'উন্নত',
  'courses.lessons': 'পাঠ',
  'courses.enrolled': 'নথিভুক্ত',
  'courses.progress': 'অগ্রগতি',
  'courses.completed': 'সম্পন্ন',
  'courses.recommended': 'সুপারিশকৃত',
  'courses.forYourLevel': 'আপনার স্তরের জন্য',
  'courses.locked': 'লক',
  'courses.unlockWith': 'প্রিমিয়াম দিয়ে আনলক করুন',

  // ==================== LESSON ====================
  'lesson.loading': 'পাঠ লোড হচ্ছে...',
  'lesson.notFound': 'পাঠ পাওয়া যায়নি',
  'lesson.quit': 'আপনি কি নিশ্চিত যে আপনি ছেড়ে দিতে চান? আপনার অগ্রগতি হারিয়ে যাবে।',
  'lesson.complete': 'পাঠ সম্পন্ন!',
  'lesson.perfect': 'পারফেক্ট!',
  'lesson.amazing': 'অসাধারণ! আপনি সব সঠিক করেছেন!',
  'lesson.xpEarned': 'XP অর্জিত',
  'lesson.accuracy': 'নির্ভুলতা',
  'lesson.correct': 'সঠিক',
  'lesson.goBack': 'ফিরে যান',
  'lesson.skip': 'এড়িয়ে যান',
  'lesson.unknownType': 'অজানা অনুশীলন ধরন',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'উত্তর দেখতে ট্যাপ করুন',
  'exercise.matchPairs': 'জোড়া মিলান',
  'exercise.matched': 'মিলেছে',
  'exercise.arrangeWords': 'শব্দ সাজান',
  'exercise.speak': 'বলুন',
  'exercise.listening': 'শুনছি... এখন বলুন!',
  'exercise.processing': 'আপনার কথা প্রসেস হচ্ছে...',
  'exercise.tapToSpeak': 'বলতে ট্যাপ করুন',
  'exercise.cantSpeak': 'এখন বলতে পারছেন না? এড়িয়ে যান',
  'exercise.again': 'আবার',
  'exercise.gotIt': 'বুঝেছি!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'উচ্চারণ অনুশীলন',
  'pronunciation.subtitle': 'AI ফিডব্যাক দিয়ে আপনার কোরিয়ান উচ্চারণ উন্নত করুন',
  'pronunciation.selectLevel': 'আপনার স্তর নির্বাচন করুন',
  'pronunciation.beginner': 'শিক্ষানবিশ',
  'pronunciation.intermediate': 'মধ্যবর্তী',
  'pronunciation.advanced': 'উন্নত',
  'pronunciation.score': 'আপনার স্কোর',
  'pronunciation.accuracy': 'নির্ভুলতা',
  'pronunciation.fluency': 'সাবলীলতা',
  'pronunciation.intonation': 'স্বরভঙ্গি',
  'pronunciation.feedback': 'প্রতিক্রিয়া',
  'pronunciation.tryAgain': 'আবার চেষ্টা করুন',
  'pronunciation.next': 'পরবর্তী',
  'pronunciation.listen': 'শুনুন',
  'pronunciation.slow': 'ধীরে',
  'pronunciation.sessionComplete': 'সেশন সম্পন্ন!',
  'pronunciation.bestScore': 'সেরা স্কোর',
  'pronunciation.average': 'গড়',
  'pronunciation.attempts': 'প্রচেষ্টা',
  'pronunciation.practiceAgain': 'আবার অনুশীলন করুন',
  'pronunciation.changeLevel': 'স্তর পরিবর্তন করুন',
  'pronunciation.tips': 'ভালো উচ্চারণের জন্য টিপস',
  'pronunciation.tip1': 'প্রথমে অডিও শুনুন',
  'pronunciation.tip2': 'স্পষ্টভাবে এবং স্থির গতিতে বলুন',
  'pronunciation.tip3': 'কঠিন শব্দের জন্য ধীর প্লেব্যাক ব্যবহার করুন',
  'pronunciation.tip4': 'শান্ত পরিবেশে অনুশীলন করুন',

  // ==================== VOCABULARY ====================
  'vocab.title': 'শব্দভাণ্ডার',
  'vocab.totalWords': 'মোট শব্দ',
  'vocab.mastered': 'আয়ত্ত',
  'vocab.dueToday': 'আজ বাকি',
  'vocab.reviewSession': 'পর্যালোচনা সেশন',
  'vocab.wordsDue': 'শব্দ পর্যালোচনার জন্য বাকি',
  'vocab.startReview': 'পর্যালোচনা শুরু করুন',
  'vocab.allCaughtUp': 'সব শেষ!',
  'vocab.noWordsDue': 'পর্যালোচনার জন্য কোনো শব্দ বাকি নেই',
  'vocab.sessionComplete': 'সেশন সম্পন্ন!',
  'vocab.allWords': 'সব শব্দ',

  // ==================== PROFILE ====================
  'profile.title': 'প্রোফাইল',
  'profile.level': 'স্তর',
  'profile.xpToNext': 'পরবর্তী স্তরের জন্য XP',
  'profile.totalXp': 'মোট XP',
  'profile.currentStreak': 'বর্তমান স্ট্রিক',
  'profile.lessonsDone': 'সম্পন্ন পাঠ',
  'profile.timeLearned': 'শেখার সময়',
  'profile.achievements': 'অর্জন',
  'profile.settings': 'সেটিংস',
  'profile.dailyGoals': 'দৈনিক লক্ষ্য',
  'profile.allAchievements': 'সব অর্জন',
  'profile.logOut': 'লগ আউট',
  'profile.koreanLevel': 'কোরিয়ান স্তর',

  // ==================== SETTINGS ====================
  'settings.title': 'সেটিংস',
  'settings.language': 'অ্যাপ ভাষা',
  'settings.preferences': 'পছন্দ',
  'settings.sound': 'শব্দ প্রভাব',
  'settings.soundEffects': 'শব্দ প্রভাব',
  'settings.soundEffectsDesc': 'অনুশীলনের উত্তর দেওয়ার সময় শব্দ বাজান',
  'settings.notifications': 'বিজ্ঞপ্তি',
  'settings.notificationsDesc': 'দৈনিক শেখার অনুস্মারক পান',
  'settings.darkMode': 'ডার্ক মোড',
  'settings.darkModeDesc': 'আরামদায়ক দেখার জন্য ডার্ক থিম',
  'settings.dailyReminder': 'দৈনিক অনুস্মারক',
  'settings.account': 'অ্যাকাউন্ট',
  'settings.editProfile': 'প্রোফাইল সম্পাদনা',
  'settings.privacy': 'গোপনীয়তা',
  'settings.help': 'সাহায্য',
  'settings.about': 'সম্পর্কে',
  'settings.retakeTest': 'লেভেল টেস্ট আবার দিন',
  'settings.retakeTestDesc': 'আপনার বর্তমান কোরিয়ান স্তর পরীক্ষা করুন',
  'settings.terms': 'সেবার শর্তাবলী',

  // ==================== FOOTER ====================
  'footer.privacy': 'গোপনীয়তা',
  'footer.terms': 'শর্তাবলী',
  'footer.contact': 'যোগাযোগ',
  'footer.rights': 'সর্বস্বত্ব সংরক্ষিত।',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'শব্দভাণ্ডার',
  'quickAction.reviewWords': 'শব্দ পর্যালোচনা করুন',
  'quickAction.allCourses': 'সব কোর্স',
  'quickAction.browseLessons': 'পাঠ ব্রাউজ করুন',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'কোর্স পাওয়া যায়নি',
  'courseDetail.lessons': 'পাঠ',
  'courseDetail.completed': 'সম্পন্ন',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'হোম',
  'bottomNav.courses': 'কোর্স',
  'bottomNav.vocab': 'শব্দভাণ্ডার',
  'bottomNav.profile': 'প্রোফাইল',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'AI টিউটর',
  'aiTutor.selectScenario': 'একটি দৃশ্যকল্প নির্বাচন করুন',
  'aiTutor.freeTalk': 'ফ্রি টক',
  'aiTutor.cafe': 'ক্যাফে অর্ডার',
  'aiTutor.shopping': 'শপিং',
  'aiTutor.restaurant': 'রেস্তোরাঁ',
  'aiTutor.friends': 'বন্ধু বানানো',
  'aiTutor.interview': 'চাকরির সাক্ষাৎকার',
  'aiTutor.typeMessage': 'একটি বার্তা টাইপ করুন...',
  'aiTutor.send': 'পাঠান',

  // ==================== ERRORS ====================
  'error.generic': 'কিছু ভুল হয়েছে',
  'error.network': 'নেটওয়ার্ক ত্রুটি। অনুগ্রহ করে আপনার সংযোগ পরীক্ষা করুন।',
  'error.notFound': 'পেজ পাওয়া যায়নি',
  'error.unauthorized': 'চালিয়ে যেতে অনুগ্রহ করে লগ ইন করুন',
  'error.microphoneAccess': 'মাইক্রোফোন অ্যাক্সেস প্রত্যাখ্যাত',
  'error.speechNotSupported': 'স্পিচ রিকগনিশন সমর্থিত নয়। Chrome ব্রাউজার চেষ্টা করুন।',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'আমরা কুকিজ ব্যবহার করি',
  'cookie.description': 'আমরা আপনার অভিজ্ঞতা উন্নত করতে, সাইট ট্রাফিক বিশ্লেষণ করতে এবং বিষয়বস্তু ব্যক্তিগতকৃত করতে কুকিজ ব্যবহার করি। আপনি অপ্রয়োজনীয় কুকিজ গ্রহণ বা প্রত্যাখ্যান করতে পারেন।',
  'cookie.learnMore': 'আরও জানুন',
  'cookie.acceptAll': 'সব গ্রহণ করুন',
  'cookie.rejectAll': 'সব প্রত্যাখ্যান করুন',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'শিখুন',
  'nav.culture': 'সংস্কৃতি',
  'nav.chat': 'চ্যাট',
  'nav.ranking': 'র‍্যাঙ্কিং',
  'nav.family': 'পরিবার',
  'nav.premium': 'প্রিমিয়াম',
  'home.greeting': 'হ্যালো',
  'home.streak': 'দিনের ধারা',
  'home.dailyGoal': 'দৈনিক লক্ষ্য',
  'home.myLanguages': 'আমার ভাষাসমূহ',
  'home.addLanguage': 'ভাষা যোগ করুন',
  'home.recommended': 'প্রস্তাবিত',
  'home.continue': 'শেখা চালিয়ে যান',
  'home.selectLanguage': 'একটি ভাষা বেছে নিন',
  'home.totalXp': 'মোট XP',
  'home.bestStreak': 'সেরা ধারা',
  'home.level': 'স্তর',
  'chat.aiTutor': 'AI টিউটর',
  'chat.aiTutorDesc': 'AI-এর সাথে কথোপকথন অনুশীলন করুন',
  'onboarding.welcome.subtitle': 'AI-চালিত কথোপকথনে যেকোনো ভাষা শিখুন',
  'onboarding.selectUILanguage': 'আপনার ভাষা বেছে নিন',
  'onboarding.selectUILanguage.subtitle': 'এটি অ্যাপ ইন্টারফেসে ব্যবহৃত হবে',
  'onboarding.selectLearningLanguage': 'আপনি কী শিখতে চান?',
  'onboarding.selectLearningLanguage.subtitle': 'আপনি একাধিক ভাষা শিখতে পারেন',
  'onboarding.selectDailyGoal': 'আপনার দৈনিক লক্ষ্য নির্ধারণ করুন',
  'onboarding.selectDailyGoal.subtitle': 'প্রতিদিন কতটা সময় দিতে পারবেন?',
  'onboarding.ready': 'আপনি প্রস্তুত!',
  'onboarding.ready.subtitle': 'চলুন আপনার ভাষা শেখার যাত্রা শুরু করি',
  'onboarding.features.languages': '৪টি ভাষা',
  'onboarding.features.aiTutor': 'AI টিউটর',
  'onboarding.features.dailyGoals': 'দৈনিক লক্ষ্য',
  'dailyGoal.5min': '৫ মিনিট',
  'dailyGoal.10min': '১০ মিনিট',
  'dailyGoal.15min': '১৫ মিনিট',
  'dailyGoal.20min': '২০ মিনিট',
  'dailyGoal.casual': 'সহজ গতি',
  'dailyGoal.regular': 'নিয়মিত অনুশীলন',
  'dailyGoal.serious': 'আগ্রহী শিক্ষার্থী',
  'dailyGoal.intense': 'নিবিড় প্রশিক্ষণ',
  'learn.title': 'শিখুন',
  'learn.currentLevel': 'বর্তমান স্তর',
  'learn.noCoursesYet': 'শীঘ্রই আসছে!',
  'learn.noCoursesDescription': 'এই ভাষার কোর্স প্রস্তুত করা হচ্ছে।',
  'learn.lessonsCompleted': 'পাঠ সম্পন্ন',
  'learn.startCourse': 'কোর্স শুরু করুন',
  'learn.continueCourse': 'চালিয়ে যান',
  'learn.courseCompleted': 'সম্পন্ন',
  'learn.locked': 'লক করা',
  'learn.unlockBy': 'আনলক করতে আগের কোর্স সম্পন্ন করুন',
  'course.progress': 'অগ্রগতি',
  'course.lessons': 'পাঠ',
  'course.lessonsCompleted': 'পাঠ সম্পন্ন',
  'course.noLessons': 'পাঠ প্রস্তুত করা হচ্ছে...',
  'lesson.tapToReveal': 'অর্থ দেখতে ট্যাপ করুন',
  'lesson.examples': 'উদাহরণ',
  'lesson.questionsCorrect': 'সঠিক',
  'lesson.wordsLearned': 'শব্দ',
  'lesson.grammarPoints': 'ব্যাকরণ',
  'lesson.backToCourse': 'কোর্সে ফিরে যান',
  'lesson.practiceAgain': 'আবার অনুশীলন করুন',
  'lesson.whatYouLearn': 'আপনি যা শিখবেন',
  'lesson.newWords': 'নতুন শব্দ',
  'lesson.exercises': 'অনুশীলন',
  'lesson.startLesson': 'পাঠ শুরু করুন',
  'lesson.reviewLesson': 'পাঠ পর্যালোচনা করুন',
  'lesson.learnVocabulary': 'শব্দভাণ্ডার শিখুন',
  'lesson.grammarPoint': 'ব্যাকরণ পয়েন্ট',
  'lesson.practice': 'অনুশীলন',
  'profile.guest': 'অতিথি',
  'profile.days': 'দিন',
  'profile.longestStreak': 'দীর্ঘতম',
  'profile.lessonsCompleted': 'সম্পন্ন',
  'profile.dailyGoal': 'দৈনিক লক্ষ্য',
  'profile.learningLanguages': 'শেখার ভাষাসমূহ',
  'profile.noLanguages': 'কোনো ভাষা নির্বাচিত হয়নি',
  'profile.minutesPerDay': 'মিনিট/দিন',
  'profile.learningHistory': 'শেখার ইতিহাস',
  'profile.viewProgress': 'আপনার অগ্রগতি দেখুন',
  'profile.appSettings': 'অ্যাপ সেটিংস',
  'profile.languageNotifications': 'ভাষা, নোটিফিকেশন',
  'profile.loginToSave': 'অগ্রগতি সংরক্ষণে লগ ইন করুন',
  'settings.learning': 'শেখা',
  'settings.dailyGoal': 'দৈনিক লক্ষ্য',
  'settings.minutesPerDay': 'প্রতিদিন মিনিট',
  'settings.selectLanguage': 'ভাষা নির্বাচন করুন',
  'settings.selectDailyGoal': 'দৈনিক লক্ষ্য নির্ধারণ করুন',
  'settings.perDay': 'প্রতিদিন',
  'settings.appInfo': 'অ্যাপ তথ্য',
  'settings.logout': 'লগ আউট',
};

export default bn;
